export default "__VITE_ASSET__DVg676yg__"